import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export class PageObjectEvaluation extends PageObject {
  score: number;
  imageGood: string;
  imageBad: string;
  soundGood: string;
  soundBad: string;
  actionGood: string;
  actionBad: string;
  evaluation: string;
  evaluated: boolean;
  evaluationResult: number;

  constructor(obj: PageObjectEvaluation = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.Evaluation;

    if (obj == null) {
      this.score = 1;
      this.imageGood = "";
      this.imageBad = "";
      this.soundGood = "";
      this.soundBad = "";
      this.actionGood = "";
      this.actionBad = "";
      this.evaluation = "";
      this.evaluated = false;
      this.evaluationResult = -1;
    } else {
      this.score = obj.score != undefined ? obj.score : 1;
      this.imageGood = obj.imageGood;
      this.imageBad = obj.imageBad;
      this.soundGood = obj.soundGood;
      this.soundBad = obj.soundBad;
      this.actionGood = obj.actionGood;
      this.actionBad = obj.actionBad;
      this.evaluation = obj.evaluation ? obj.evaluation : "";
      this.evaluated = obj.evaluated;
      this.evaluationResult = obj.evaluationResult;
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();

    list.push(new ObjectProperty("Score", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Image Good", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Image Bad", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Sound Good", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Sound Bad", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Action Good", OBJECTPROPERTYTYPE.TextLong));
    list.push(new ObjectProperty("Action Bad", OBJECTPROPERTYTYPE.TextLong));
    list.push(new ObjectProperty("Evaluation", OBJECTPROPERTYTYPE.TextLong));

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Score") {
      return this.score;
    } else if (name == "Image Good") {
      return this.imageGood;
    } else if (name == "Image Bad") {
      return this.imageBad;
    } else if (name == "Sound Good") {
      return this.soundGood;
    } else if (name == "Sound Bad") {
      return this.soundBad;
    } else if (name == "Action Good") {
      return this.actionGood;
    } else if (name == "Action Bad") {
      return this.actionBad;
    } else if (name == "Evaluation") {
      return this.evaluation;
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    super.setPropertyValue(name, value, style);

    if (name == "Score") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        if (newValue > 0) {
          this.score = newValue;
        }
      }
    } else if (name == "Image Good") {
      this.imageGood = value;
    } else if (name == "Image Bad") {
      this.imageBad = value;
    } else if (name == "Sound Good") {
      this.soundGood = value;
    } else if (name == "Sound Bad") {
      this.soundBad = value;
    } else if (name == "Action Good") {
      this.actionGood = value;
    } else if (name == "Action Bad") {
      this.actionBad = value;
    } else if (name == "Evaluation") {
      this.evaluation = value;
    }
  }
}
